import request from "@/utils/request"

const applyChurnDiscount = () =>
  request.post("/api/churn_prevention_discount", {
    token: true
  })

export default {
  applyChurnDiscount
}
